export default __webpack_public_path__ + "static/media/star-empty.9d2e6d1b.svg";